export default "__VITE_ASSET__Ah3Yg2vM__"